// extracted by mini-css-extract-plugin
export default {"quill_wrapper":"style-module__quill_wrapper___y3QVo"};